import React from "react";

interface AvatarProps {
  avatarUrl?: string;
  name?: string;
  size?: number; // tailwind size, e.g. 8 for h-8 w-8
  className?: string;
}

// Reason: Abstracts avatar/placeholder logic for reuse across app
const Avatar: React.FC<AvatarProps> = ({ avatarUrl, name, size = 8, className = "" }) => {
  const sizeClass = `h-${size} w-${size}`;
  if (avatarUrl) {
    return (
      <img
        className={`${sizeClass} rounded-full ${className}`}
        src={avatarUrl}
        alt="User avatar"
      />
    );
  }
  const initials = name
    ? name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : null;
  return (
    <span
      className={`${sizeClass} flex items-center justify-center rounded-full bg-indigo-500 text-white font-semibold text-sm ${className}`}
      data-testid="avatar-placeholder"
    >
      {initials || (
        <svg
          className="h-5 w-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5.121 17.804A9 9 0 1112 21a9.003 9.003 0 01-6.879-3.196z"
          />
        </svg>
      )}
    </span>
  );
};

export default Avatar;
